export default __webpack_public_path__ + "static/media/Cole.e8aac938.png";